import { margin, height } from '@10d/tend-ui-styling';
import { css } from 'styled-components';

/**
 * @deprecated Перенести стили в RangePicker и удалить, больше не использовать
 * Не для публичного использования
 */
const datePickerCss = css `
  &.tend-ui-picker {
    ${props => {
    if (props.$fullWidth)
        return css `
          width: 100%;
        `;
    return css `
        width: ${props.$width || '256px'};
      `;
}}

    ${margin};
    ${height};
  }

  &.tend-ui-picker-dropdown {
    .tend-ui-picker-month-btn {
      text-transform: uppercase;
    }

    .tend-ui-picker-header {
      padding: 8px 16px;
    }

    .tend-ui-picker-header-super-prev-btn,
    .tend-ui-picker-header-super-next-btn {
      display: none;
    }

    .tend-ui-picker-date-panel .tend-ui-picker-body {
      padding: 8px 16px;
    }
  }

  &.tend-ui-picker-dropdown .tend-ui-picker-year-panel .tend-ui-picker-cell-inner,
  &.tend-ui-picker-dropdown .tend-ui-picker-quarter-panel .tend-ui-picker-cell-inner,
  &.tend-ui-picker-dropdown .tend-ui-picker-month-panel .tend-ui-picker-cell-inner {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: capitalize;
  }
`;

export { datePickerCss };
//# sourceMappingURL=datePicker.js.map
